import { useEffect, useState } from 'react';
import { addQuery } from 'Helpers/Query';
import fr from 'facet-rest';

import useCollection from 'Hooks/useCollection';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';

export default function useMetaTable(coll, args = {}) {
  const {
    tableMetaOverrideSet,
    columns = [],
    linkQueryParamName,
  } = args;

  const [tableColumns, setTableColumns] = useState(columns);
  const { collection, setCollection } = useCollection();

  useEffect(() => {
    async function loadTableFromCollection() {
      let collectionWithOverride = coll;
      if (typeof coll === 'string') {
        const collectionLink = coll;
        try {
          const response = await fr.http.Get(collectionLink);
          collectionWithOverride = fr.collection(response);
        } catch (err) {
          displayErrorMessage(err, err.errors);
        }
      }

      if (tableMetaOverrideSet) {
        collectionWithOverride = collectionWithOverride?.overrideMeta(tableMetaOverrideSet);
      }

      const nonHiddenFields = collectionWithOverride?.meta()?.template()?.list()?.filter(v => !v.attr('hidden')) ?? [];

      setCollection(collectionWithOverride);


      if (collectionWithOverride && collectionWithOverride.link('self')) {
        addQuery({ [linkQueryParamName]: collectionWithOverride.link('self').url() });
      }


      setTableColumns(nonHiddenFields.map((template) => {
        return ({
          name: template.attr('name'),
          ...template.attr('_column'),
        });
      }));
    }
    loadTableFromCollection();
  }, []);

  const setCollectionAndUpdateQueryParam = (updatedCollection) => {
    let c = updatedCollection;
    if (tableMetaOverrideSet && updatedCollection) {
      c = updatedCollection.overrideMeta(tableMetaOverrideSet);
    }
    setCollection(c);
    if (c && c.link('self')) {
      addQuery({ [linkQueryParamName]: c.link('self').url() });
    }
  };

  return {
    collection,
    columns: tableColumns,
    setCollection: setCollectionAndUpdateQueryParam,
  };
}
